/* Publish by EComposer at 2026-10-17 09:03:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y8eru130b9"]=  window.__ectimmers["ecom-y8eru130b9"] || {};
if(!this.$el)return;const t=this.$el,o=t.querySelector(".ecom-text_view-more-btn"),e=t.querySelector(".ecom-text_view-less-btn"),i=t.querySelector(".text-content.ecom-html");!i||(o&&o.addEventListener("click",()=>{i.classList.remove("ecom-text--is-mark"),i.style.maxHeight="",o.style.display="none",e.style.display=""}),e&&e.addEventListener("click",()=>{i.classList.add("ecom-text--is-mark"),i.style.maxHeight="var(--ecom-text-height)",e.style.display="none",o.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-y8eru130b9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y8eru130b9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zs5n561q2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zs5n561q2b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bml6ow0fiau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bml6ow0fiau', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-82rx8l7uq9s"]=  window.__ectimmers["ecom-82rx8l7uq9s"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let o=this.$el;if(!o)return;function e(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function i(){let n=o.querySelector(".ecom-element.ecom-base-image"),s=o.closest(".core__row--columns");n&&(e(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){i()})

                    });
                    
                        document.querySelectorAll('.ecom-82rx8l7uq9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-82rx8l7uq9s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3tyo9dwla02').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3tyo9dwla02', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wnsx139eln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wnsx139eln', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ma5b8g5m258').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ma5b8g5m258', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mwosns4z3ug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mwosns4z3ug', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}